const Hero = () => {
  return <div className="Hero"></div>;
};

export default Hero;
